import React from 'react';
import VstComponent from './VstComponent';
import addClassName from '../utils/add-class-name';
import copyProps from '../utils/copy-props';
import classNames from 'classnames';
import namespaceOptions from '../utils/namespace-options';

class VstSelect extends VstComponent {

  render() {
    let props = addClassName(this.props, classNames(namespaceOptions('vst', this.props.options), 'vst-select'));
    props = copyProps(props, ['options', 'data', 'label', 'items']);

    return (
      <div className={classNames('vst-form-group', namespaceOptions('vst-form-group', this.props.options))}>
        <label className="vst-label vst-label-select" htmlFor={this.props.id}>{this.props.label}</label>
        <select {...props}>
          {this.props.items.map((option) => <option key={`option-${this.props.id}-${option.value}`} value={option.value}>{option.label}</option>)}
          <optgroup label=""></optgroup>
        </select>
      </div>
    );
  }
}

export default VstSelect;
